import React, { useCallback, useEffect, useState } from "react";
import ConstantsImages from "../../../constants/ConstantsImages";
import ConstantsTexts from "../../../constants/ConstantsTexts";
import ApiService from "../../../data/ApiService";
import UtilsUnit from "../../../utils/UtilsUnit";
import useUtilsUnit from "../../../utils/useUtilsUnit";
import WidgetIcon from "../../icons/widget-icon/WidgetIcon";
import WidgetTooltipWrapper from "../widget-tooltip-wrapper/WidgetTooltipWrapper";
import WidgetAlertDialogPendingRequests from "../../alert-dialogs/widget-alert-dialog-pending-requests/WidgetAlertDialogPendingRequests";
import "./WidgetChangeRequestsIcon.css";

export const PENDING_CHANGE_REQUESTS_CHANGED_EVENT = "pending-change-requests-changed";

const WidgetChangeRequestsIcon = () => {
  const { userData } = useUtilsUnit({ userData: true });
  const [pendingRequestsCount, setPendingRequestsCount] = useState(0);
  const [hasLoadedCount, setHasLoadedCount] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const userID = userData ? UtilsUnit.getUserID(userData) : undefined;

  const loadCount = useCallback(async () => {
    if (!userID) {
      setPendingRequestsCount(0);
      setHasLoadedCount(true);
      return;
    }

    const count = await ApiService.getPendingChangeRequestsCount();
    setPendingRequestsCount(count);
    setHasLoadedCount(true);
  }, [userID]);

  useEffect(() => {
    let isMounted = true;

    const load = async () => {
      if (!userID) {
        return;
      }

      const count = await ApiService.getPendingChangeRequestsCount();
      if (isMounted) {
        setPendingRequestsCount(count);
        setHasLoadedCount(true);
      }
    };

    load();

    const handlePendingRequestsChanged = () => {
      loadCount();
    };

    window.addEventListener(PENDING_CHANGE_REQUESTS_CHANGED_EVENT, handlePendingRequestsChanged);

    return () => {
      isMounted = false;
      window.removeEventListener(PENDING_CHANGE_REQUESTS_CHANGED_EVENT, handlePendingRequestsChanged);
    };
  }, [userID, loadCount]);

  const badgeLabel = pendingRequestsCount > 99 ? "99+" : String(pendingRequestsCount);

  if (!isDialogOpen && (!hasLoadedCount || pendingRequestsCount === 0)) {
    return null;
  }

  return (
    <>
      <div className="widget-change-requests-icon-wrap">
        <WidgetTooltipWrapper content={ConstantsTexts.CODE_254}>
          <WidgetIcon
            iconProp={ConstantsImages.BELL_IMAGE}
            widthIconProp="1.8rem"
            heightIconProp="1.8rem"
            backgroundColorProp="#2e2e2e"
            customClassNameProp="widget-change-requests-icon"
            handleOnClickProp={() => setIsDialogOpen(true)}
          />
        </WidgetTooltipWrapper>
        {pendingRequestsCount > 0 && <span className="widget-change-requests-badge">{badgeLabel}</span>}
      </div>
      {isDialogOpen && (
        <WidgetAlertDialogPendingRequests
          onClose={() => {
            setIsDialogOpen(false);
            loadCount();
          }}
        />
      )}
    </>
  );
};

export default WidgetChangeRequestsIcon;
